<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      :title="_title"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      
    >

       <list @get-select="getSelect" v-show="bool" :is-show="false"></list>  
       <stock-list @get-select="getSelect" v-show="!bool" :is-show="false"></stock-list>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/views/business/purchase/emptor/index";
import stockList from "@/views/business/purchase/stock/index";

export default {
  mixins: [editDialogMixin],
  props: {
    bool: {
        type: Boolean,
        default: true,
    },
    _title: {
        type: String,
        default: ''
    }
  },
  components: {
    commonDialog,
    list,
    stockList
  },
  methods: {
    getSelect(row){
      console.log('row', row)
      this.$emit('get-select', row);
      this.close();
    }
  }
  
};
</script>
